module.exports = __webpack_public_path__ + "img/66.464f2e64.png";